import { lazy } from 'react';

const CustomPlanificationsObjectivesAdditionals = lazy(() => import('./CustomPlanificationsObjectivesAdditionals'));

export default CustomPlanificationsObjectivesAdditionals;
